import { render, staticRenderFns } from "./floors.vue?vue&type=template&id=6e2b0cd2&scoped=true"
import script from "./floors.vue?vue&type=script&lang=js"
export * from "./floors.vue?vue&type=script&lang=js"
import style0 from "./floors.vue?vue&type=style&index=0&id=6e2b0cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b0cd2",
  null
  
)

export default component.exports